<template>
        <LayoutPage
            imageName="map-bg.jpg">
            <template v-slot:banner>
                <BannerSmallerWithSearchAndButton
                    :imageName="$t('UI.banners.smallerBannerImage')"
                    :title="$te('organizationPage.title') ? $t('organizationPage.title') : ''"
                    :description="$te('organizationPage.description') ? $t('organizationPage.description') : ''"
                />
            </template>
            <template v-slot:content v-if="isReady">
                <div class="box box--space-top">
                    <div v-if="$te('organizationPage.contentHeading') && $te('organizationPage.featureIconListsA')"
                        class="mm-section">
                        <div class="mm-section-content">
                            <div class="container-fluid w-100">
                                <div class="box box--center box--space-vertical">
                                    <span
                                        class="headline headline--second pt-5">
                                        {{$t('organizationPage.contentHeading')}}
                                    </span>
                                </div>
                                <div class="row mb-5 mt-5">
                                    <div class="col-12">
                                        <SmallIconFeatureList
                                            iconClassName="mm-hp-icon-3x"
                                            itemClassName="col-md-3 col-sm-6"
                                            textIconClassName="text--bigger-paragraph"
                                            :list="$t('organizationPage.featureIconListsA')"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="$te('organizationPage.timelineBanners.title')"
                        class="mm-section"
                        style="background-color: rgb(240, 240, 240)">
                        <div class="mm-section-content">
                            <div class="container-fluid w-100">
                                <div class="row">
                                    <div class="col-12 box box--center box--space-top">
                                         <span class="headline headline--second pt-5">
                                            {{$t('organizationPage.timelineBanners.title')}}
                                        </span>

                                        <span v-if="$te('organizationPage.timelineBanners.description')"
                                            class="headline headline--fifth pt-4 pb-4">
                                            {{$t('organizationPage.timelineBanners.description')}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <TimelineBanner
                        v-if="$te('organizationPage.timelineBanners.slots')"
                        :items="$t('organizationPage.timelineBanners.slots')" />

                    <div class="box box--center box--space-inside box--no-space-inside-top box--grey">
                        <div class="box box--space-bottom">
                            <router-link
                                :to="localeRoute('pricing')"
                                class="button button button--wider-border button--small-text transparent--button button--l button--uppercase button--float-left">
                                {{$t('organizationPage.buttonPricing')}}
                            </router-link>
                        </div>
                    </div>


                    <div class="mm-section"
                        :style="{
                            minHeight: '100px',
                            padding: '1rem 0',
                            background: 'linear-gradient(270deg, rgba(0,174,186,0.4) 0%, rgba(0,174,186,0.7) 100%)'
                        }">
                        <div class="mm-section-content d-flex justify-content-center box--center">
                            <span class="headline headline--third headline--white mb-0">
                                {{$t('organizationPage.compositionsHeading')}}
                            </span>
                        </div>
                    </div>

                    <LayoutPopular
                        :themesRequestState="themesRequestState">
                        <template v-slot:horizontalLinks>
                            <HorizontalScrollMenu
                                v-if="links"
                                :links="links"
                                :activeLink="activeLink"
                                :onClick="onLinkClick"
                            />
                        </template>
                        <template v-slot:links>
                            <SidebarLinks
                                v-if="links"
                                :links="links"
                                :activeLink="activeLink"
                                :onClick="onLinkClick"
                            />
                        </template>
                        <template v-slot:themes>
                            <div class="box box--left">
                                <Themes
                                    v-if="themes"
                                    :themes="themes"
                                    :onThemeClick="onThemeClick"
                                    containerClassName="row"
                                    itemClassName="col-md-6 col-lg-6 col-xl-4 col-sm-6 col-xs-12"
                                />
                            </div>
                        </template>
                    </LayoutPopular>
                </div>
            </template>
    </LayoutPage>
</template>

<script>
import { setPageTitle, setMeta, getPageTitle, getPageMetaDescription } from '@/utils/meta'
import LayoutPage from '@/components/layouts/Page';
import BannerSmallerWithSearchAndButton from '@/components/ui/Banner/SmallerWithSearchAndButton';
import SmallIconFeatureList from '@/components/solutions/smallIconFeatureList';
import Themes from '@/components/ui/Themes';
import SidebarLinks from '@/components/ui/SidebarLinks';
import HorizontalScrollMenu from '@/components/ui/HorizontalScrollMenu';
import LayoutPopular from '@/components/layouts/Popular';

import TimelineBanner from '@/components/ui/TimeLineBanner';
import { openMapComposition, getThemesPromise } from '@/services/MapsfyApi';

export default {
    components: {
        SmallIconFeatureList,
        LayoutPage,
        BannerSmallerWithSearchAndButton,
        TimelineBanner,
        Themes,
        SidebarLinks,
        HorizontalScrollMenu,
        LayoutPopular
    },
    created: function() {
        setPageTitle(getPageTitle(this.$route));
        setMeta("description", getPageMetaDescription(this.$route));

    },
    mounted: function() {
        var item = this.getActiveItem();
        if (item) {
            this.loadData(item.geom);
        }
    },
    data() {
        return {
            isReady: this.$te('organizationPage'),
            themesRequestState: null,
            themes: null,
            activeLink: this.$te("organizationPage.defaultActiveTheme") &&
                this.$t('organizationPage.defaultActiveTheme'),
            links: this.$te("organizationPage.themes") &&
                this.$t('organizationPage.themes')
        };
    },
    methods: {
        getActiveItem() {
            if (this.links) {
                var item = this.links.find(item => item.id === this.activeLink);
                return item;
            }

            return false;
        },
        onLinkClick(link) {
            this.activeLink = link.id;
            if (link.geom) {
                this.loadData(link.geom);
            }
        },
        onThemeClick(theme) {
            this.$router.push({name: 'mapApp'});
            openMapComposition(theme.hash);
        },
        loadData(bbox) {
            this.themesRequestState = "request";
            getThemesPromise('municipality', bbox)
                .then(res => {
                    this.themesRequestState = "success";
                    this.themes = res;
                })
                .fail(() => {
                    this.themesRequestState = "failure";
                });
        }
    }
}
</script>
